export function getName(person) {
  // First try the new data structure (summary.name)
  if (person.summary?.name) {
    return person.summary.name
  }

  // Fallback to nameForms structure
  if (person.summary?.nameForms?.length > 0) {
    return person.summary.nameForms[0].fullText
  }

  // Legacy structure fallback
  return (
    person.names?.length > 0 &&
    person.names[0]?.value?.nameForms?.length > 0 &&
    person.names[0]?.value?.nameForms[0]?.fullText
  )
}

export function getSurname(person) {
  // First try to get surname from nameForms parts
  if (person.summary?.nameForms?.length > 0) {
    const nameForm = person.summary.nameForms[0]
    if (nameForm.parts) {
      const surnamepart = nameForm.parts.find((part) => part.type === 'http://gedcomx.org/Surname')
      if (surnamepart) {
        return surnamepart.value
      }
    }
  }

  // Fallback to parsing the full name
  const name = getName(person)
  const nameSplit = name && name.split(' ')
  return nameSplit ? nameSplit[nameSplit.length - 1] : ''
}

export function getBirthDate(person) {
  if (person.summary && person.summary.lifespanBegin && person.summary.lifespanBegin.date) {
    if (person.summary.lifespanBegin.date.normalized && person.summary.lifespanBegin.date.normalized.length > 0) {
      return person.summary.lifespanBegin.date.normalized[0].value
    }
    return person.summary.lifespanBegin.date.formal
  }
  return ''
}

export function getBirthPlace(person) {
  if (person.summary && person.summary.lifespanBegin && person.summary.lifespanBegin.place) {
    if (person.summary.lifespanBegin.place.names && person.summary.lifespanBegin.place.names.length > 0) {
      return person.summary.lifespanBegin.place.names[0].value
    }
    return person.summary.lifespanBegin.place.original || ''
  }
  return ''
}

export function getDeathDate(person, t) {
  if (person.summary && !person.summary.living) {
    if (person.summary.lifespanEnd && person.summary.lifespanEnd.date) {
      if (
        person.summary.lifespanEnd.date.normalized &&
        person.summary.lifespanEnd.date.normalized.length > 0 &&
        person.summary.lifespanEnd.date.normalized[0].value
      ) {
        return person.summary.lifespanEnd.date.normalized[0].value
      }
      return person.summary.lifespanEnd.date.formal ? person.summary.lifespanEnd.date.formal : t('deceased', 'Deceased')
    }
    return t('deceased', 'Deceased')
  }
  return t('living', 'Living')
}

export function getDeathPlace(person) {
  if (person.summary && !person.summary.living) {
    if (person.summary.lifespanEnd && person.summary.lifespanEnd.place) {
      if (
        person.summary.lifespanEnd.place.names &&
        person.summary.lifespanEnd.place.names.length > 0 &&
        person.summary.lifespanEnd.place.names[0].value
      ) {
        return person.summary.lifespanEnd.place.names[0].value
      }
      return person.summary.lifespanEnd.place.original || ''
    }
  }
  return ''
}
